import {sortBookedByDate} from 'presentation/utils';
import {FilterAndSortBookedAppointmentsParams} from './types';

export const filterAndSortBookedAppointments = ({
	filter,
	appointments,
}: FilterAndSortBookedAppointmentsParams) => {
	const filteredAppointments =
		filter === '' ? appointments : appointments.filter(item => item.bookingType === filter);

	if (filteredAppointments.length === 0) {
		return [];
	}

	const sortedAppointments = sortBookedByDate({
		list: filteredAppointments || [],
		order: 'desc',
	});

	return sortedAppointments;
};
